// import React, { useState, useEffect } from 'react';
// import { updateCategoryByID } from '../../Constant/Api/Api';
// import { TagsInput, Textarea, Checkbox, Progress, Modal, TextInput, Button } from '@mantine/core';
// import { useDisclosure } from '@mantine/hooks';
// import uploadFile from '../../firebase/firebaseUploadFunction';
// import { MdDelete } from "react-icons/md";


// // Helper function to normalize image data structure
// const normalizeImage = (image) => {
//     if (!image) return null;

//     // If it's already in new format
//     if (typeof image === 'object' && image.url) {
//         return image;
//     }
//     // If it's old format (string), convert to new format
//     if (typeof image === 'string') {
//         return {
//             url: image,
//             metaData: {
//                 sizeOfImage: 0, // Default value for existing images
//             },
//         };
//     }
//     return null;
// };

// function EditCategory({ category, onClose }) {
//     const [opened, { open, close }] = useDisclosure(true);
//     const [categoryID, setCategoryID] = useState('');
//     const [categoryName, setCategoryName] = useState('');
//     const [metaName, setMetaName] = useState('');
//     const [name2, setName2] = useState('');
//     const [categoryDescription, setCategoryDescription] = useState('');
//     const [metaDescription, setMetaDescription] = useState('');
//     const [secondDescription, setSecondDescription] = useState('');
//     const [categoryImage, setCategoryImage] = useState(null);
//     const [slug, setSlug] = useState(category.slug || '');
//     const [imageUploadingLoader, setImageUploadingLoader] = useState(false);
//     const [showOnHeader, setShowOnHeader] = useState(category.showOnHeader || false);
//     const [tags, setTags] = useState(category.tags || []);

//     useEffect(() => {
//         if (category) {
//             setCategoryID(category._id || '');
//             setCategoryName(category.name || '');
//             setMetaName(category.metaName || '');
//             setName2(category.name2 || '');
//             setCategoryDescription(category.description || '');
//             setMetaDescription(category.metaDescription || '');
//             setSecondDescription(category.secondDescription || '');
//             setCategoryImage(normalizeImage(category.categoryImage));
//             setSlug(category.slug || '');
//             setShowOnHeader(category.showOnHeader || false);
//             setTags(category.tags || []);
//         }
//     }, [category]);

//     const handleCategoryChange = (event) => {
//         setCategoryName(event.target.value);
//     };

//     const handleMetaNameChange = (event) => {
//         setMetaName(event.target.value);
//     };

//     const handleName2Change = (event) => {
//         setName2(event.target.value);
//     };

//     const handleDescriptionChange = (event) => {
//         setCategoryDescription(event.target.value);
//     };

//     const handleMetaDescriptionChange = (event) => {
//         setMetaDescription(event.target.value);
//     };

//     const handleSecondDescriptionChange = (event) => {
//         setSecondDescription(event.target.value);
//     };

//     const handleSlugChange = (event) => {
//         setSlug(event.target.value);
//     };

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];

//         if (!file) return;

//         // Check file size (100KB = 100 * 1024 bytes)
//         const maxSize = 100 * 1024;

//         if (file.size > maxSize) {
//             alert("Image size should not exceed 100KB");
//             e.target.value = '';
//             return;
//         }

//         setImageUploadingLoader(true);
//         uploadFile(e)
//             .then((fireBaseUrl) => {
//                 // Create new image object structure
//                 const imageObject = {
//                     url: fireBaseUrl,
//                     metaData: {
//                         sizeOfImage: (file.size / 1000).toFixed(2),
//                     }
//                 };
//                 setCategoryImage(imageObject);
//                 setImageUploadingLoader(false);
//             })
//             .catch((error) => {
//                 setImageUploadingLoader(false);
//                 console.error('Error:', error);
//             });
//     };

//     const handleDeleteImage = () => {
//         setCategoryImage(null);
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         console.log("submitted");

//         try {
//             const token = localStorage.getItem('token');

//             const formData = {
//                 name: categoryName,
//                 metaName: metaName || categoryName,
//                 name2: name2,
//                 description: categoryDescription,
//                 metaDescription: metaDescription || categoryDescription,
//                 secondDescription: secondDescription,
//                 categoryImage: categoryImage,
//                 showOnHeader: showOnHeader,
//                 tags: tags,
//                 slug
//             };

//             const response = await fetch(`${updateCategoryByID}${categoryID}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//                 body: JSON.stringify(formData),
//             });

//             const data = await response.json();
//             console.log('Success:', formData);

//             if (data) {
//                 onClose(); // Close the modal on successful submission
//             }
//         } catch (error) {
//             console.error('Error updating category:', error);
//         }
//     };

//     return (
//         <div>
//             <Modal opened={opened} onClose={onClose} size="lg" title="Update Category">
//                 <form onSubmit={handleSubmit} className='space-y-2'>
//                     {imageUploadingLoader ? (
//                         <>
//                             <span className='bg-red-50'>please wait while image is uploading... </span>
//                             <Progress radius="xl" value={100} striped animated />
//                         </>
//                     ) : (
//                         categoryImage && (
//                             <div className="mb-4 relative">
//                                 <img
//                                     src={categoryImage.url}
//                                     alt="Category"
//                                     className='w-full h-36 object-cover rounded'
//                                 />
//                                 <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
//                                     {categoryImage.metaData?.sizeOfImage || 0} KB
//                                 </div>
//                                 <button
//                                     type="button"
//                                     onClick={handleDeleteImage}
//                                     className="absolute top-2 left-2 bg-red-500 text-white rounded-full p-1"
//                                 >
//                                     <MdDelete size={16} />
//                                 </button>
//                             </div>
//                         )
//                     )}

//                     <TextInput
//                         label="Category Name"
//                         placeholder="Enter category name"
//                         value={categoryName}
//                         onChange={handleCategoryChange}
//                     />
//                     <TextInput
//                         label="Meta Title (SEO)"
//                         placeholder="Enter meta title"
//                         value={metaName}
//                         onChange={handleMetaNameChange}
//                     />
//                     <TextInput
//                         label="Second Name"
//                         placeholder="Enter second name"
//                         value={name2}
//                         onChange={handleName2Change}
//                     />
//                     <TextInput
//                         label="Slug"
//                         placeholder="Enter category Slug (eg: road-safety-equipment)"
//                         value={slug}
//                         onChange={handleSlugChange}
//                     />
//                     <Textarea
//                         label="Description"
//                         placeholder="Enter category description"
//                         value={categoryDescription}
//                         onChange={handleDescriptionChange}
//                     />
//                     <Textarea
//                         label="Meta Description (SEO)"
//                         placeholder="Enter meta description"
//                         value={metaDescription}
//                         onChange={handleMetaDescriptionChange}
//                     />
//                     <Textarea
//                         label="Second Description"
//                         placeholder="Enter second description"
//                         value={secondDescription}
//                         onChange={handleSecondDescriptionChange}
//                     />

//                     <div className="mb-4">
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Category Image
//                         </label>
//                         <input
//                             type="file"
//                             accept='image/*'
//                             placeholder="Select image"
//                             onChange={handleImageChange}
//                             disabled={imageUploadingLoader}
//                             className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
//                         />
//                         {imageUploadingLoader && (
//                             <p className="text-sm text-blue-600 mt-2">Uploading image...</p>
//                         )}
//                     </div>

//                     <TagsInput
//                         label="Press Enter to submit a tag"
//                         placeholder="Enter tag"
//                         value={tags}
//                         onChange={setTags}
//                     />
//                     <Checkbox
//                         label="Show on header"
//                         checked={showOnHeader}
//                         onChange={(e) => setShowOnHeader(e.currentTarget.checked)}
//                     />

//                     <Button type="submit" disabled={imageUploadingLoader}>
//                         {imageUploadingLoader ? 'Uploading...' : 'Update'}
//                     </Button>
//                 </form>
//             </Modal>
//         </div>
//     );
// }

// export default EditCategory;



// Add this to your EditCategory component

import React, { useState, useEffect } from 'react';
import { updateCategoryByID, uploadCategoryPDF, deleteCategoryPDF } from '../../Constant/Api/Api';
import { TagsInput, Textarea, Checkbox, Progress, Modal, TextInput, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import uploadFile from '../../firebase/firebaseUploadFunction';
import { MdDelete, MdPictureAsPdf, MdDownload } from "react-icons/md";


// Helper function to normalize image data structure
const normalizeImage = (image) => {
    if (!image) return null;
    if (typeof image === 'object' && image.url) {
        return image;
    }
    if (typeof image === 'string') {
        return {
            url: image,
            metaData: {
                sizeOfImage: 0,
            },
        };
    }
    return null;
};

function EditCategory({ category, onClose }) {
    const [opened, { open, close }] = useDisclosure(true);
    const [categoryID, setCategoryID] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [metaName, setMetaName] = useState('');
    const [name2, setName2] = useState('');
    const [categoryDescription, setCategoryDescription] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [secondDescription, setSecondDescription] = useState('');
    const [categoryImage, setCategoryImage] = useState(null);
    const [slug, setSlug] = useState(category.slug || '');
    const [imageUploadingLoader, setImageUploadingLoader] = useState(false);
    const [showOnHeader, setShowOnHeader] = useState(category.showOnHeader || false);
    const [tags, setTags] = useState(category.tags || []);

    // PDF related states
    const [pdfFile, setPdfFile] = useState(null);
    const [pdfUploadingLoader, setPdfUploadingLoader] = useState(false);

    useEffect(() => {
        if (category) {
            setCategoryID(category._id || '');
            setCategoryName(category.name || '');
            setMetaName(category.metaName || '');
            setName2(category.name2 || '');
            setCategoryDescription(category.description || '');
            setMetaDescription(category.metaDescription || '');
            setSecondDescription(category.secondDescription || '');
            setCategoryImage(normalizeImage(category.categoryImage));
            setSlug(category.slug || '');
            setShowOnHeader(category.showOnHeader || false);
            setTags(category.tags || []);
            setPdfFile(category.pdfFile || null);
        }
    }, [category]);

    const handleCategoryChange = (event) => {
        setCategoryName(event.target.value);
    };

    const handleMetaNameChange = (event) => {
        setMetaName(event.target.value);
    };

    const handleName2Change = (event) => {
        setName2(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setCategoryDescription(event.target.value);
    };

    const handleMetaDescriptionChange = (event) => {
        setMetaDescription(event.target.value);
    };

    const handleSecondDescriptionChange = (event) => {
        setSecondDescription(event.target.value);
    };

    const handleSlugChange = (event) => {
        setSlug(event.target.value);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const maxSize = 100 * 1024;

        if (file.size > maxSize) {
            alert("Image size should not exceed 100KB");
            e.target.value = '';
            return;
        }

        setImageUploadingLoader(true);
        uploadFile(e)
            .then((fireBaseUrl) => {
                const imageObject = {
                    url: fireBaseUrl,
                    metaData: {
                        sizeOfImage: (file.size / 1000).toFixed(2),
                    }
                };
                setCategoryImage(imageObject);
                setImageUploadingLoader(false);
            })
            .catch((error) => {
                setImageUploadingLoader(false);
                console.error('Error:', error);
            });
    };

    const handleDeleteImage = () => {
        setCategoryImage(null);
    };

    // PDF handling functions
    const handlePDFChange = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        // Check file type
        if (file.type !== 'application/pdf') {
            alert("Please select a PDF file");
            e.target.value = '';
            return;
        }

        // Check file size (2MB = 2 * 1024 * 1024 bytes)
        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
            alert("PDF size should not exceed 2MB");
            e.target.value = '';
            return;
        }

        setPdfUploadingLoader(true);

        try {
            const token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('pdfFile', file);
            formData.append('categorySlug', slug);

            const response = await fetch(`${uploadCategoryPDF}${categoryID}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                setPdfFile(data.pdfInfo);
                alert("PDF uploaded successfully!");
            } else {
                alert(data.error || "Error uploading PDF");
            }
        } catch (error) {
            console.error('Error uploading PDF:', error);
            alert("Error uploading PDF");
        } finally {
            setPdfUploadingLoader(false);
            e.target.value = '';
        }
    };

    const handleDeletePDF = async () => {
        if (!window.confirm("Are you sure you want to delete this PDF?")) {
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${deleteCategoryPDF}${categoryID}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (response.ok) {
                setPdfFile(null);
                alert("PDF deleted successfully!");
            } else {
                alert(data.error || "Error deleting PDF");
            }
        } catch (error) {
            console.error('Error deleting PDF:', error);
            alert("Error deleting PDF");
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("submitted");

        try {
            const token = localStorage.getItem('token');

            const formData = {
                name: categoryName,
                metaName: metaName || categoryName,
                name2: name2,
                description: categoryDescription,
                metaDescription: metaDescription || categoryDescription,
                secondDescription: secondDescription,
                categoryImage: categoryImage,
                showOnHeader: showOnHeader,
                tags: tags,
                slug,
                pdfFile: pdfFile
            };

            const response = await fetch(`${updateCategoryByID}${categoryID}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            console.log('Success:', formData);

            if (data) {
                onClose();
            }
        } catch (error) {
            console.error('Error updating category:', error);
        }
    };

    return (
        <div>
            <Modal opened={opened} onClose={onClose} size="lg" title="Update Category">
                <form onSubmit={handleSubmit} className='space-y-2'>
                    {/* Image upload section */}
                    {imageUploadingLoader ? (
                        <>
                            <span className='bg-red-50'>please wait while image is uploading... </span>
                            <Progress radius="xl" value={100} striped animated />
                        </>
                    ) : (
                        categoryImage && (
                            <div className="mb-4 relative">
                                <img
                                    src={categoryImage.url}
                                    alt="Category"
                                    className='w-full h-36 object-cover rounded'
                                />
                                <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
                                    {categoryImage.metaData?.sizeOfImage || 0} KB
                                </div>
                                <button
                                    type="button"
                                    onClick={handleDeleteImage}
                                    className="absolute top-2 left-2 bg-red-500 text-white rounded-full p-1"
                                >
                                    <MdDelete size={16} />
                                </button>
                            </div>
                        )
                    )}

                    <TextInput
                        label="Category Name"
                        placeholder="Enter category name"
                        value={categoryName}
                        onChange={handleCategoryChange}
                    />
                    <TextInput
                        label="Meta Title (SEO)"
                        placeholder="Enter meta title"
                        value={metaName}
                        onChange={handleMetaNameChange}
                    />
                    <TextInput
                        label="Second Name"
                        placeholder="Enter second name"
                        value={name2}
                        onChange={handleName2Change}
                    />
                    <TextInput
                        label="Slug"
                        placeholder="Enter category Slug (eg: road-safety-equipment)"
                        value={slug}
                        onChange={handleSlugChange}
                    />
                    <Textarea
                        label="Description"
                        placeholder="Enter category description"
                        value={categoryDescription}
                        onChange={handleDescriptionChange}
                    />
                    <Textarea
                        label="Meta Description (SEO)"
                        placeholder="Enter meta description"
                        value={metaDescription}
                        onChange={handleMetaDescriptionChange}
                    />
                    <Textarea
                        label="Second Description"
                        placeholder="Enter second description"
                        value={secondDescription}
                        onChange={handleSecondDescriptionChange}
                    />

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Category Image
                        </label>
                        <input
                            type="file"
                            accept='image/*'
                            placeholder="Select image"
                            onChange={handleImageChange}
                            disabled={imageUploadingLoader}
                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                        />
                        {imageUploadingLoader && (
                            <p className="text-sm text-blue-600 mt-2">Uploading image...</p>
                        )}
                    </div>

                    {/* PDF upload section */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Category PDF (Max 2MB)
                        </label>

                        {/* Show current PDF if exists */}
                        {pdfFile && (
                            <div className="mb-3 p-3 bg-gray-50 rounded border">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-2">
                                        <MdPictureAsPdf className="text-red-500" size={24} />
                                        <div>
                                            <p className="text-sm font-medium">
                                                {pdfFile.metaData?.originalName || `${slug}.pdf`}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                                {pdfFile.metaData?.sizeOfFile || 0} KB
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <a
                                            href={pdfFile.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 hover:text-blue-700"
                                        >
                                            <MdDownload size={20} />
                                        </a>
                                        <button
                                            type="button"
                                            onClick={handleDeletePDF}
                                            className="text-red-500 hover:text-red-700"
                                        >
                                            <MdDelete size={20} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <input
                            type="file"
                            accept='application/pdf'
                            placeholder="Select PDF file"
                            onChange={handlePDFChange}
                            disabled={pdfUploadingLoader}
                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
                        />
                        {pdfUploadingLoader && (
                            <>
                                <p className="text-sm text-green-600 mt-2">Uploading PDF...</p>
                                <Progress radius="xl" value={100} striped animated />
                            </>
                        )}
                    </div>

                    <TagsInput
                        label="Press Enter to submit a tag"
                        placeholder="Enter tag"
                        value={tags}
                        onChange={setTags}
                    />
                    <Checkbox
                        label="Show on header"
                        checked={showOnHeader}
                        onChange={(e) => setShowOnHeader(e.currentTarget.checked)}
                    />

                    <Button type="submit" disabled={imageUploadingLoader || pdfUploadingLoader}>
                        {imageUploadingLoader || pdfUploadingLoader ? 'Uploading...' : 'Update'}
                    </Button>
                </form>
            </Modal>
        </div>
    );
}

export default EditCategory;